module.exports = __webpack_public_path__ + "media/images/top-banner-2-b6f3b99874fec27b17d8fa512892b5cd.jpg";